import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';
import NavigationButtons from '../../../NavigationButtons';
import { formatNumber } from '../../../../../utils/numberFormatter';
import 'react-loading-skeleton/dist/skeleton.css';
import '../DownpaymentPlans.css';

const CONTINUE_BUTTON_ID = 'offer-continue-btn';

const OffersList = ({
  plans = [],
  selectedPlan = null,
  onSelectPlan,
  onNext,
  loading = false,
  onGoBack = null,
  backLabel = null
}) => {
  const renderSkeletons = () => {
    return (
      <div className="row justify-content-center mt-3">
        {[...Array(3)].map((_, index) => (
          <div className="col-md-4" key={index}>
            <div className="card rg-sale-plan-tile rg-tile rg-tile--skeleton rg-tile--skeleton-plan" aria-hidden="true">
              <div className="card-body text-center">
                <div className="rg-tile__body">
                  <Skeleton height={18} width={86} />
                  <Skeleton height={30} width={138} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (loading) {
    return renderSkeletons();
  }

  if (plans.length === 0) {
    return null;
  }

  const regularPlans = plans.filter(plan => !plan.is_downpayment_plan);
  const downpaymentPlans = plans.filter(plan => plan.is_downpayment_plan);
  const hasDownpaymentPlans = downpaymentPlans.length > 0;

  const focusContinueButton = () => {
    setTimeout(() => {
      document.getElementById(CONTINUE_BUTTON_ID)?.focus();
    }, 0);
  };

  const handlePlanSelection = (plan) => {
    onSelectPlan(plan);
    focusContinueButton();
  };

  const renderPlanCard = (plan) => (
    <div
      key={plan.id}
      className={`card rg-sale-plan-tile rg-tile ${selectedPlan?.id === plan.id ? 'selected' : ''} ${plan.is_downpayment_plan ? 'downpayment-plan' : ''}`}
      onClick={() => handlePlanSelection(plan)}
      style={{ cursor: 'pointer' }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handlePlanSelection(plan);
        }
      }}
    >
      <div className="card-body text-center">
        {plan.is_downpayment_plan && plan.plan_name && (
          <div className="rg-sale-plan-label mb-2">
            <span className="badge bg-primary">{plan.plan_name}</span>
          </div>
        )}
        <div className="rg-tile__body">
          <h4 className="card-text rg-tile__title">{plan.installments} cuotas de</h4>
          <p className="card-title rg-tile__amount">
            {`$${formatNumber(plan.installment_amount)}`}
          </p>
        </div>
        {plan.is_downpayment_plan && (
          <div className="downpayment-plan-details mt-2">
            <p className="mb-1 text-primary">
              <small>
                <strong>Pago Requerido</strong><br/>
                {plan.downpayment_type === 'percentage'
                  ? `${plan.downpayment_value}% del capital ($${formatNumber(plan.downpayment_amount)})`
                  : `${plan.downpayment_value} cuota${plan.downpayment_value > 1 ? 's' : ''} ($${formatNumber(plan.downpayment_amount)})`
                }
              </small>
            </p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {plans.length > 0 && (
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-md-12 text-center fs-5">
            <p className="text-muted mb-0">
              Primera cuota: <strong>{plans[0].display_date_formatted}</strong>
            </p>
          </div>
        </div>
      )}

      <div id="plansContainer" className="row justify-content-center mt-2">
        {regularPlans.map((plan) => (
          <div className="col-md-4" key={plan.id}>
            {renderPlanCard(plan)}
          </div>
        ))}
      </div>

      {hasDownpaymentPlans && (
        <div className="row justify-content-center mt-2">
          {downpaymentPlans.map((plan) => (
            <div className="col-md-4" key={plan.id}>
              {renderPlanCard(plan)}
            </div>
          ))}
        </div>
      )}

      {hasDownpaymentPlans && (
        <div className="row justify-content-center mt-3">
          <div className="col-md-12">
            <div className="m-0 px-3 py-2 shadow rounded-2 text-primary rg-sale-quote-notice" role="alert">
              <div className="d-flex align-items-start">
                <div>
                  <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                  <strong>Atención</strong>
                  <br/>
                  <p>Los planes que requieren anticipo deben abonarse en el momento de confirmar la compra.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <NavigationButtons
        primaryButtonId={CONTINUE_BUTTON_ID}
        onNext={onNext}
        nextLabel="Continuar"
        onBack={onGoBack}
        backLabel={backLabel}
      />
    </>
  );
};

export default OffersList;
